import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Tasks from './components/tasks/tasks';
import Chat from './components/chat/chat';
import Contacts from './components/contacts/contacts';
import './App.css';
import Login from './components/login/login';
import MainMenu from './components/mainMenu';
import Client from './components/client/client';
import Documents from './components/documents/Documents';
import DiagPage from './components/diag/DiagPage';
import { AccountBadgesProvider } from './context/AccountBadgesContext';
import { SectionMenuResetProvider } from './context/SectionMenuResetContext';

function AppLayout() {
  const location = useLocation();

  return (
    <AccountBadgesProvider>
      <SectionMenuResetProvider>
      <div>
        {(location.pathname !== "/" && location.pathname !== "/diag") && <MainMenu />}

        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/client" element={<Client />} />
          <Route path="/documents" element={<Documents />} />
          <Route path="/tasks" element={<Tasks />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/diag" element={<DiagPage />} />
        </Routes>
      </div>
      </SectionMenuResetProvider>
    </AccountBadgesProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}

export default App;
